import { useEffect, type ReactNode } from 'react';

/**
 * CHAT-DUET (his pick, 2026-10-28): the menu the chat box's + opens - Attach files, Read answers aloud, Voice chat,
 * History - instead of a row of small text controls over the box. A white card just above the box with a light dim
 * behind it; a tap on the dim or Escape closes it. The caller owns `open` (and closes it after a row that should).
 * ⚠️ The caller wraps the box in a `relative` element so the card opens right above it.
 */
export const MENU_ROW =
  'flex min-h-[56px] w-full min-w-0 items-center gap-3 rounded-[14px] px-3 py-2 text-left transition-colors hover:bg-gray-50 disabled:opacity-50';

/** The on/off picture at the end of a switch row. Decoration only: the row itself is the control, and says its state. */
export function MenuSwitch({ on }: { on: boolean }) {
  return (
    <span aria-hidden="true" className={`relative h-7 w-[46px] shrink-0 rounded-full transition-colors ${on ? 'bg-chat-black' : 'bg-gray-300'}`}>
      <span className={`absolute top-[3px] h-[22px] w-[22px] rounded-full bg-white shadow transition-[left] ${on ? 'left-[21px]' : 'left-[3px]'}`} />
    </span>
  );
}

export function PlusMenu({ open, onClose, children }: { open: boolean; onClose: () => void; children: ReactNode }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <>
      <div data-testid="plus-menu-dim" aria-hidden="true" onClick={onClose} className="fixed inset-0 z-20 bg-black/20" />
      <div
        role="group"
        aria-label="More options"
        className="absolute inset-x-0 bottom-full z-30 mb-2 max-h-[60vh] overflow-y-auto rounded-[20px] bg-white p-1.5 shadow-chat-card"
      >
        {children}
      </div>
    </>
  );
}
